<template>
  <v-app-bar
    app
    color="#fcb69f"
    dark
    src="https://haikubox-images.s3.amazonaws.com/web/header.jpeg"
  >
    <!-- <v-toolbar-title class="mx-2" style="cursor: pointer" @click="goToHaikuboxDotCom()">HAIKUBOX
    </v-toolbar-title> -->

    <v-btn icon @click="goHome()" aria-label="Home"> 
      <router-link style="text-decoration: none; color: inherit" to="/haikubox"  aria-hidden="true"  tabindex="-1"
        ><v-icon alt="home" aria-hidden="true">mdi-home</v-icon>
      </router-link>
    </v-btn>

    <v-btn icon @click="toggleMap()"  aria-label="Map">
      <router-link style="text-decoration: none; color: inherit" to="/haikubox"  aria-hidden="true"  tabindex="-1">
        <v-icon alt="map" aria-hidden="true">mdi-map-search</v-icon>
      </router-link>
    </v-btn>

    <v-btn icon @click="toggleBadge()"  aria-label="Badges">
      <router-link style="text-decoration: none; color: inherit" to="/haikubox"  aria-hidden="true"  tabindex="-1">
        <v-icon alt="labeling badges" aria-hidden="true">mdi-trophy</v-icon>
      </router-link>
    </v-btn>

    <v-btn icon   aria-label="Notifications">
      <router-link
        style="text-decoration: none; color: inherit"
        to="/notifications"
        aria-hidden="true"
        tabindex="-1"
        ><v-icon alt="notifications" aria-hidden="true">mdi-bell</v-icon>
      </router-link>
    </v-btn>

    <v-btn icon aria-label="Favorites">
      <router-link
        style="text-decoration: none; color: inherit"
        to="/favorites"
        aria-hidden="true"
        tabindex="-1"
        ><v-icon alt="favorites" aria-hidden="true">mdi-star</v-icon>
      </router-link>
    </v-btn>

    <v-spacer  tabindex="-1"  aria-hidden="true"></v-spacer>
    <!-- <v-btn
      icon
      v-tooltip.bottom-start="'Label'"
    >
      <router-link style="text-decoration: none; color: inherit;" to="/label"
        ><v-icon>mdi-label-multiple-outline</v-icon></router-link
      >
    </v-btn> -->

    <!-- <v-btn icon v-tooltip.bottom-start="'Marine'">
      <router-link style="text-decoration: none; color: inherit;" to="/marine"
        ><v-icon>mdi-shark-fin</v-icon></router-link
      >
    </v-btn> -->


    <v-btn
      icon
      v-if="
        (this.user != '60c05843-732f-4d66-a49a-bd39658cdacb') &
        (this.user != '332232a5-51da-4f3e-a260-d83fdd959b12')
      "
        aria-label="Account Settings"
    >
      <router-link style="text-decoration: none; color: inherit" to="/settings"  aria-hidden="true"  tabindex="-1"
        ><v-icon alt="account settings">mdi-account-circle</v-icon></router-link
      >
    </v-btn>

    <v-btn icon @click="navigateTo('https://haikubox.com/support-haikubox')" aria-label="Help">
      <v-icon alt="help link">mdi-help-circle-outline</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  props: ["user", "email"],
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {
    goHome() {
      // console.log("HeaderSignedIn goHome");
      this.$emit("goHome");
    },
    goToHaikuboxDotCom() {
      // console.log("open haikubox.com");
      window.location.href = "https://haikubox.com";
    },
    toggleMap() {
      this.$emit("toggleMap");
      window.scrollTo(0, 0);
    },
    toggleBadge() {
      this.$emit("toggleBadge");
      window.scrollTo(0, 0);
    },
    changeLanguage() {
      this.$i18n.locale = this.selectedLanguage;
    },
    navigateTo(url) {
      if (navigator.userAgent.indexOf("gonative") > -1){
        window.location.href = 'gonative://window/open?url=' + url + '&mode=appbrowser';
      }
      else{
        window.open(url, '_blank');
      } 
    }
  },
};
</script>

<style>
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
</style>
